var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer my-2"},[_c('b-form-select',{attrs:{"options":_vm.langs,"size":"sm"},on:{"change":function($event){return _vm.onLanguageChanged()}},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }